import { useAtomAction } from '@lighthouse/shared'
import { useAtomCallback } from 'jotai/utils'
import { findLast } from 'rambda'
import { useCallback } from 'react'

import { toggleFloatBoxAtom } from '@/atoms/application/action'
import { pageStackOfFloatBlockAtom } from '@/atoms/application/state'
import { pageStackAtomFamily } from '@/atoms/page/state'
import { useCurrentStackIdContext } from '@/contexts/PageContext'

import { usePageStackActions } from './usePageStackActions'

export const useFloat = () => {
    const stackId = useCurrentStackIdContext()
    const { closeCurrentPageLayer } = usePageStackActions()
    const { run: toggleFloat } = useAtomAction(toggleFloatBoxAtom)

    const closeFloat = useAtomCallback(
        useCallback(
            get => {
                const lastOpenFloat = findLast(v => v.open && v.stackId === stackId, get(pageStackOfFloatBlockAtom))
                if (lastOpenFloat) {
                    toggleFloat({ ...lastOpenFloat, open: false })
                    return
                }
                const pageStackDisplayType = get(pageStackAtomFamily(stackId))?.pageStackDisplayType
                if (pageStackDisplayType === 'modal' || pageStackDisplayType === 'drawer') {
                    closeCurrentPageLayer()
                }
            },
            [closeCurrentPageLayer, stackId, toggleFloat]
        )
    )

    return { closeFloat }
}
